import { render } from "./PendingExpiredReportRender.vue?vue&type=template&id=5f0dcc2a"
import script from "./PendingExpiredReportRender.vue?vue&type=script&lang=js"
export * from "./PendingExpiredReportRender.vue?vue&type=script&lang=js"
script.render = render

export default script